export function buildHourOptions(): { value: number; label: string }[] {
  const options = [];
  for (let h = 1; h <= 12; h++) {
    options.push({ value: h, label: String(h) });
  }
  return options;
}

export function buildMinuteOptions(): { value: string; label: string }[] {
  const options = [];
  for (let m = 0; m < 60; m += 15) {
    const val = String(m).padStart(2, '0');
    options.push({ value: val, label: val });
  }
  return options;
}

export function to12h(time24: string): { hour12: number; minute: string; ampm: string } {
  const [h, m] = time24.split(':').map(Number);
  return {
    hour12: h === 0 ? 12 : h > 12 ? h - 12 : h,
    minute: String(m).padStart(2, '0'),
    ampm: h < 12 ? 'AM' : 'PM',
  };
}

export function to24h(hour: number, minute: string, ampm: string): string {
  let h24 = hour;
  if (ampm === 'AM' && hour === 12) h24 = 0;
  else if (ampm === 'PM' && hour !== 12) h24 = hour + 12;
  return `${String(h24).padStart(2, '0')}:${minute}`;
}

export function todayDateString(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}
